import React from 'react';
import './styles/mobile.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './components/layout/DashboardLayout';
import Button from './components/ui/Button';
import Card from './components/ui/Card';

// Pages
import LandingPage from './features/landing/LandingPage';
import LoginPage from './features/auth/LoginPage';
import CadastroPage from './features/auth/CadastroPage';
import DashboardPage from './features/dashboard/DashboardPage';
import SimuladorPage from './features/simulador/SimuladorPage';
import CRMPage from './features/crm/CRMPage';
import SimulacoesSalvasPage from './features/simulador/SimulacoesSalvasPage';
import PdfsGeradosPage from './features/relatorios/PdfsGeradosPage';
import PerformancePage from './features/relatorios/PerformancePage';
import ContaPage from './features/conta/Contapage';
import { ThemeProvider } from './contexts/Themecontext';
import { UserProvider } from './contexts/UserContext';
import UsuariosPage from './features/usuarios/UsuariosPage';
import AdminPage from './features/admin/AdminPage';
// Páginas públicas — Produto
import { ApiPage } from './pages/ApiPage';

// Páginas públicas — Empresa
import { SobrePage, BlogPage, ContatoPage, CarreirasPage } from './pages/EmpresaPages';

// Páginas públicas — Suporte
import { AjudaPage, StatusPage, WhatsAppPage } from './pages/SuportePages';
import BlogPostPage from './pages/BlogPostPage';
import BlogAdminPage from './pages/BlogAdminPage';
import DocsPage from './pages/DocsPage';


const today = new Date().toLocaleDateString('pt-BR', {
  weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
});

const pages = {
  '/dashboard': {
    title: 'Dashboard', subtitle: today, Component: DashboardPage,
  },
  '/simulador': {
    title: 'Nova Simulação', subtitle: 'Compare financiamentos de múltiplos bancos',
    Component: SimuladorPage,
    actions: <Button variant="ghost">📄 Exportar PDF</Button>,
  },
  '/crm': {
    title: 'CRM', subtitle: 'Gestão de clientes e negócios',
    Component: CRMPage, actions: null,
  },
  '/simulacoes': {
    title: 'Simulações Salvas',
    subtitle: 'Histórico de todas as simulações realizadas',
    Component: SimulacoesSalvasPage,
  },
  '/pdfs': {
    title: 'PDFs Gerados',
    subtitle: 'Histórico de PDFs exportados',
    Component: PdfsGeradosPage,
  },
  '/performance': {
    title: 'Performance',
    subtitle: 'Análise de desempenho e métricas',
    Component: PerformancePage,
  },
  '/conta': { title: 'Conta', subtitle: 'Configurações da conta', Component: ContaPage },
  '/usuarios': { title: 'Usuários', subtitle: 'Gerenciar usuários e equipes', Component: UsuariosPage },
  '/Admin': { title: 'Admin', subtitle: 'Gerenciar sistema', Component: AdminPage },
};

const placeholders = [
  { path: '/pipeline',    title: 'Pipeline' },
  { path: '/tarefas',     title: 'Tarefas' },
  { path: '/whitelabel',  title: 'White Label' },
  { path: '/integracoes', title: 'Integrações' },
];

function PlaceholderPage({ title }) {
  return (
    <Card style={{ textAlign: 'center', padding: 80 }}>
      <p style={{ fontSize: '1.2rem', fontWeight: 600, marginBottom: 8 }}>{title}</p>
      <p style={{ color: 'var(--text-muted)' }}>Em breve</p>
    </Card>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <UserProvider>
        <BrowserRouter>
          <Routes>

            {/* ── Páginas públicas ──────────────────────────────── */}
            <Route path="/"          element={<LandingPage />} />
            <Route path="/login"     element={<LoginPage />} />
            <Route path="/cadastro"  element={<CadastroPage />} />

            {/* Produto */}
            <Route path="/api"       element={<ApiPage />} />

            {/* Empresa */}
            <Route path="/sobre"     element={<SobrePage />} />
            <Route path="/blog"      element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/contato"   element={<ContatoPage />} />
            <Route path="/carreiras" element={<CarreirasPage />} />

            {/* Suporte */}
            <Route path="/ajuda"     element={<AjudaPage />} />
            <Route path="/status"    element={<StatusPage />} />
            <Route path="/whatsapp"  element={<WhatsAppPage />} />
            <Route path="/docs"      element={<DocsPage />} />

             {/* Admin */}
              <Route path="/admin-blog"      element={<BlogAdminPage />} />
            {/* ── App interno (com sidebar) ─────────────────────── */}
            {Object.entries(pages).map(([path, { title, subtitle, Component, actions }]) => (
              <Route
                key={path}
                path={path}
                element={
                  <DashboardLayout title={title} subtitle={subtitle} topbarActions={actions}>
                    <Component />
                  </DashboardLayout>
                }
              />
            ))}

            {/* Placeholders */}
            {placeholders.map(({ path, title }) => (
              <Route
                key={path}
                path={path}
                element={
                  <DashboardLayout title={title} subtitle="">
                    <PlaceholderPage title={title} />
                  </DashboardLayout>
                }
              />
            ))}

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />

          </Routes>
        </BrowserRouter>
      </UserProvider>
    </ThemeProvider>
  );
}